import React from 'react';
import { Button, Icon } from '@doxyme/ui';
import './TroubleshootingWizardHeader.scss';
export const TroubleshootingWizardHeader = ({ title, onClose }) => {
    return (<div className='troubleshooting-wizard-header'>
      <div className='troubleshooting-wizard-header__title'>{title}</div>
      <Button className="troubleshooting-wizard-header__close" onClick={onClose} btnStyle="flat" size="small" color="black" iconOnly>
        <Icon className="troubleshooting-wizard-header__close-icon" name="call-settings-close" size="xx-small"/>
      </Button>
    </div>);
};
